import $ from 'jquery';

import Confirmer from './confirm';
import Error from './error';

class AddCreditNote {

	constructor() {
		
		if ($(".credit-notes-form").length > 0) {
			this.init();
		}

	}

	init() {

		
		$(".note-invoice").each((i, group) => {

			let checkbox = $(group).find("input[type=checkbox]");
			let field = $(group).find("input.form-control");

			$(checkbox).change(e => {
				$(field).prop("readonly", !($(checkbox).prop("checked")));
				this.updateTotal();
			}).change();

			$(field).change(e => {
				this.updateTotal();
			});

		});


	}

	updateTotal() {
		let total = $("#note-total");
		let amount = 0;
		$(".note-invoice").each((i, group) => {

			let checkbox = $(group).find("input[type=checkbox]");
			let field = $(group).find("input.form-control");

			if ($(checkbox).prop("checked")) {
				let n = 1 * $(field).val();
				if (isNaN(n)) {
					n = 0;
				}
				amount += n;
			}

			$(total).val(amount);

		});
	}


}

export default AddCreditNote;
